import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const InviteToCreateAccountMutation = graphql.persisted(
  "InviteToCreateAccount",
  graphql(`
    mutation InviteToCreateAccount($personId: ID!, $email: String, $confirmUnknown: Boolean) {
      inviteToCreateAccount(input: { personId: $personId, email: $email, confirmUnknown: $confirmUnknown }) {
        person {
          id
          hasUserAccount
          accountInviteStatus
          accountInviteEmail
          accountInviteExpiresAt
        }
        userErrors { message path }
      }
    }
  `)
);

export { InviteToCreateAccountMutation };

export function useInviteToCreateAccount() {
  return useMutation(InviteToCreateAccountMutation);
}
